import React from 'react';

import ContactVerification from '@/modules/user/components/ContactVerification/ContactVerification';

const ContactVerificationPage = () => (
  <ContactVerification />
);

export default ContactVerificationPage;
